module.exports = __webpack_public_path__ + "media/fonts/SeptemberMornings-4024cb0ddd4efab6cba150ef7d8045dc.ttf";